<div class="pageWrapper">
    <ol class="progressBar">
        <li class="progressBar-item px-12" [class.active]="page.IsDone || page.IsActive" *ngFor="let page of pages">
            <!-- <div class="progressBar-step"> -->
            <div class="progressBar-step" [class]="(listType === 'Companies' || listType === 'Contacts') && pages.length === 1 ? 'progressBar-step-withoutpercentage': ''">
                <h5>{{page.Title}}</h5>
                <!-- <span class="span-padding">{{page.Description}}</span> -->
                <span *ngIf="pages.length > 1 || (listType !== 'Companies' && listType !== 'Contacts')" class="span-padding">{{page.Description}}</span>
                <fa-icon *ngIf="page.IsDone" class="actionable_element progressBar-check" [icon]="['fas', 'check']"></fa-icon>
            </div>
        </li>
    </ol>
</div>
